export default __webpack_public_path__ + "05bbbdde7ef4d4a297d2079bc1d07e29.png";